import ShortCSSVars from '@ux/short-css-vars';
import stringHash from 'string-hash';

let shortVarsInstance;

const formatter = (name) => 'ux-' + stringHash(name).toString(36);

/**
 * Convert a dot-notation Intent to a CSS Custom Property
 * @param {Array<String>|String} intent - A dot-notation Intent path as a string
 * @returns {String} - A CSS Custom Property
 */
function toCssCustomProperty(intent) {

  if (!shortVarsInstance) {
    shortVarsInstance = new ShortCSSVars({ formatter });
  }

  const parts = Array.isArray(intent)
    ? intent.filter(Boolean)
    : intent.toString().split('.');

  if (parts[0].startsWith('intent')) {
    parts.shift();
  }

  parts[parts.length - 1] = `-${parts[parts.length - 1]}`;

  return shortVarsInstance.replaceName(`--${parts.join('-')}`);
}

export default toCssCustomProperty;
